import { render } from "./ProxyTokenMintAccountComponent.vue?vue&type=template&id=f2d28f98&scoped=true"
import script from "./ProxyTokenMintAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProxyTokenMintAccountComponent.vue?vue&type=script&lang=js"

import "./ProxyTokenMintAccountComponent.vue?vue&type=style&index=0&id=f2d28f98&lang=css"
import "./ProxyTokenMintAccountComponent.vue?vue&type=style&index=1&id=f2d28f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d28f98"]])

export default __exports__